module.exports = __webpack_public_path__ + "media/images/pause-icon-white-5c789ff1.png";